/** Demo workflow routes — readable register, thumb-zone CTAs. */

export function isDemoWorkflowPath(pathname) {
  return pathname === "/demo" || pathname.startsWith("/demo/");
}

/** Sticky demo CTA height — DevGuestBar lifts above this on demo routes. */
export const DEMO_STICKY_BAR_LIFT = "calc(5.875rem + env(safe-area-inset-bottom, 0px))";

/** Page bottom padding when a demo sticky bar is present. */
export const DEMO_PAGE_PB_STICKY = "pb-28";
